var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevicePhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0588 0H8.94118C7.31765 0.001625 6.00191 1.12 6 2.5V29.5C6.00191 30.88 7.31765 31.9984 8.94118 32H23.0588C24.6824 31.9984 25.9981 30.88 26 29.5V2.5C25.9981 1.12 24.6824 0.001625 23.0588 0ZM24.8235 29.5C24.8235 30.3284 24.0335 31 23.0588 31H8.94118C7.96654 31 7.17647 30.3284 7.17647 29.5V26.5H24.8235V29.5ZM24.8235 25.5H7.17647V5.5H24.8235V25.5ZM24.8235 4.5H7.17647V2.5C7.17647 1.67156 7.96654 1 8.94118 1H23.0588C24.0335 1 24.8235 1.67156 24.8235 2.5V4.5Z",
    fill: "#969EB1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 27C15.1716 27 14.5 27.6716 14.5 28.5C14.5 29.3284 15.1716 30 16 30C16.8284 30 17.5 29.3284 17.5 28.5C17.5 27.6716 16.8284 27 16 27ZM16 29C15.7239 29 15.5 28.7761 15.5 28.5C15.5 28.2239 15.7239 28 16 28C16.2761 28 16.5 28.2239 16.5 28.5C16.5 28.7761 16.2761 29 16 29Z",
    fill: "#969EB1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 2.5H14C13.7239 2.5 13.5 2.72387 13.5 3C13.5 3.27613 13.7239 3.5 14 3.5H18C18.2761 3.5 18.5 3.27613 18.5 3C18.5 2.72387 18.2761 2.5 18 2.5Z",
    fill: "#969EB1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicePhone);
export default __webpack_public_path__ + "static/media/device-phone.ff6747bebef43ebf53420b41c86554b2.svg";
export { ForwardRef as ReactComponent };